<template>
  <div class="content-container">
    <div class="top-control-container">
      <!-- <div class="button-containers">
        <button class="btn primary medium" @click="attachData">Tìm kiếm</button>
      </div> -->
    </div>
    <!-- Search Component -->
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <!-- <div class="das-form-col col-8">
            <div class="das-form-input">
              <div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp3"
                    v-model="searchParams.isShowNonActive"
                    type="checkbox"
                    @change="attachData"
                  />
                  <label for="cpSpdTp3">{{
                    $t('views.configuration.showPackageCategoryNotWorking')
                  }}</label>
                </div>
              </div>
            </div>
          </div> -->
          <div class="das-form-col col-4">
            <div class="das-form-input">
              <div class="label">{{ $t('field.showRoomServiceGroup') }}</div>
              <el-select
                v-model="searchParams.active"
                placeholder=""
                @change="attachData"
              >
                <el-option
                  v-for="item in packCategoryActiveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-form :inline="true" class="demo-form-inline" style="margin: 20px 0">
      <el-form-item label="Đơn vị">
        <el-select placeholder="Select" style="width: 100%">
          <el-option />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-checkbox>Hiển thị Danh mục gói không hoạt động</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">Tìm kiếm</el-button>
      </el-form-item>
    </el-form> -->

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :auto-size-cell="true"
        :columns="columns"
        :rows="rows"
        dom-layout="scroll"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="onSelectRows"
      />
    </div>
    <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="!enableDelete"
        @click="deletePackageCategory"
      >
        {{ $t('button.deleteCategory') }}
      </button>
      <button
        class="btn primary small"
        :disabled="!enableEdit"
        @click="fnOpenEditDialog"
      >
        {{ $t('button.modifyCategory') }}
      </button>
      <button class="btn primary small" @click="fnOpenAddDialog">
        {{ $t('button.addCategory') }}
      </button>
      <!-- <button class="btn primary small outline">Sửa thuế</button> -->
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button type="primary" @click="dialogFormVisible = true">
        Thêm danh mục
      </el-button>
      <el-button type="danger" @click="deletePackageCategory">
        Xóa danh mục
      </el-button>
    </el-col> -->
    <el-dialog
      :title="
        isEditDialog
          ? $t('dialog.titlePackageCategoryModify')
          : $t('dialog.titlePackageCategoryAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <!-- <el-form :model="form">
        <el-form-item label="Mã danh mục">
          <el-input v-model="form.code" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Mô tả">
          <el-input
            v-model="form.desc"
            type="textarea"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
        <el-form-item label="Hoạt động">
          <el-switch v-model="form.active" />
        </el-form-item>
      </el-form> -->

      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.packageCategoryCode') }}
                  </div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    :name="$t('field.packageCategoryCode')"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        :readonly="isEditDialog"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">{{ $t('field.desc') }}</div>
                  <validation-provider rules="max:200" :name="$t('field.desc')">
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col">
                <div class="das-form-input flex align-center">
                  <div class="label" style="margin-right: 5px">
                    {{ $t('field.active') }}
                  </div>
                  <el-switch
                    v-model="form.active"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updatePackageCategory"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addPackageCategory">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import bus from '@/utils/bus'
/* eslint-disable */
import {
  getPackageCategoryApi,
  updatePackageCategoryApi,
  addPackageCategoryApi,
  deletePackageCategoryApi
} from '@/api/Service_Policy/packageCategory'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderToggleSwitchReadOnly
  },
  data() {
    return {
      loading: true,
      form: {
        code: '',
        desc: '',
        active: true,
        id: null
      },
      totalPage: 0,
      currentPage: 0,
      isEditDialog: false,

      // FOR DISABLING BUTTONS
      enableEdit: false,
      enableDelete: false,

      dialogFormVisible: false,
      searchParams: {
        pageSize: null,
        pageNum: null,
        isShowNonActive: false,
        active: null
      },
      columns: [
        {
          headerdesc: '',
          // field: "index",
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.categoryCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          flex: 1,
          minWidth: 200
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.active
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 100
        }
      ],
      rows: [],
      packCategoryActiveOptions: [
        {
          value: null,
          label: this.$t('variables.all')
        },
        {
          value: true,
          label: this.$t('variables.active')
        },
        {
          value: false,
          label: this.$t('variables.nonActive')
        }
      ]
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible
        ? null
        : setTimeout(() => {
            this.resetPackageCategoryInfo()
          }, 500)
    }
  },
  beforeMount() {
    // this.context = { componentParent: this };
  },
  mounted() {
    this.attachData()
    this.gridApi = this.$refs.agGrid.gridApi
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      this.attachData
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      let data = await getPackageCategoryApi(this.searchParams)
      // bus.$emit('endLoader')
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addPackageCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      addPackageCategoryApi(this.form)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updatePackageCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      updatePackageCategoryApi(this.form)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deletePackageCategory() {
      const rowsSelected = this.gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (!id_list?.length) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectPackageCategory')
        })
      } else {
        // this.$confirm("Bạn chắc chắn muốn xoá danh mục này?", "Warning", {
        //   confirmButtonText: "OK",
        //   cancelButtonText: "Cancel",
        //   type: "warning",
        // }).then(() => {
        //   deletePackageCategoryApi(id_list)
        //     .then(() => {
        //       this.$message({
        //         type: "success",
        //         message: "Bạn đã xoá danh mục thành công",
        //       });
        //       this.attachData();
        //     })
        //     .catch(() => {
        //       this.dialogFoonSelectRowsrmVisible = false;
        //     });
        // });
        this.$vxConfirm(this.$t('alert.deletePackageCategory'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deletePackageCategoryApi(id_list)
              .then(() => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    // DIALOG
    fnOpenAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
    },

    fnOpenEditDialog() {
      this.isEditDialog = true
      this.dialogFormVisible = true
      const selectedRow = this.gridApi.getSelectedRows()[0]
      this.form = {
        code: selectedRow.code,
        desc: selectedRow.desc,
        active: selectedRow.active,
        id: selectedRow.id
      }
    },

    onSelectRows(rows) {
      this.enableDelete = !!rows.length
      this.enableEdit = rows?.length == 1
    },

    onDoubleClicked(rows) {
      this.isEditDialog = true
      const rowData = rows[0]
      this.form.code = rowData.code
      this.form.desc = rowData.desc
      this.form.active = rowData.active
      this.form.id = rowData.id

      this.dialogFormVisible = true
    },
    resetPackageCategoryInfo() {
      // this.isEditDialog = false;
      this.form = {
        code: '',
        desc: '',
        active: true,
        id: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
